/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const pause = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.222 2h-1.11A1.1 1.1 0 0 0 3 3.09v9.82A1.1 1.1 0 0 0 4.111 14h1.111a1.1 1.1 0 0 0 1.111-1.09V3.09A1.1 1.1 0 0 0 5.223 2Zm6.667 0h-1.111a1.1 1.1 0 0 0-1.111 1.09v9.82a1.1 1.1 0 0 0 1.11 1.09h1.112A1.1 1.1 0 0 0 13 12.91V3.09C13 2.489 12.502 2 11.889 2Z"
    />
  </svg>
)
export default pause
